/*
  useBotech.js
*/

// Npm.
import { useContext } from 'react';

// Contexts.
import BotechContext from '../contexts/BotechContext';

/**
 * Hook to return botech context.
 */
export default function useBotech() {

  return useContext(BotechContext);

}
